const React = require('react');
import {
  PERMISSION_EDIT_BANK_DETAILS,
} from '../../../../../constants/permissions';
import {
  isUserAccessed,
} from '../../../../../emitters/account';
const Button = require('../../../../dumb/Button/C');
const Caption = require('../../../../dumb/Caption/C');
const {
  cryptoAccountId$,
} = require('./state');
const CryptoAccounts = require('./components/CryptoAccounts');

module.exports = (props) => {
  const disabled = !isUserAccessed(PERMISSION_EDIT_BANK_DETAILS);

  return (
    <div className={props.className || ''}>
      <div className="layoutRow fhaB fvaC fxwWrap">
        <Caption className="fxUnset@m wsUnset@m">Your crypto deposit accounts</Caption>
        <Button
          className="w170 mv-5 mv10@m"
          // disabled={disabled}
          onClick={() => {
            cryptoAccountId$.emit('create');
          }}
        >
          New account
        </Button>
      </div>
      <CryptoAccounts
        className="mt35"
        disabled={disabled}
      />
    </div>
  );
};
